import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SelectUI from '../../../widgets/input/SelectUI'
import { Label, Legend, Line, LineChart, Text, Tooltip, XAxis, YAxis } from 'recharts'
import './Charts.css'

const ChartsUI = ({
  chartYearlyData, lastMonthsChartData, chartFromAprilData, quaterlyData,
  lastMonths, onLastMonthsChange, lastMonthsList,
  financialYear, onFinancialYearChange, financialYearList,
  showGpVNp, onShowGpVNp, showExpensesChart, onShowExpensesChart, selectLine, dataKeys
}) =>
  <div className='c_chrt'>
    <CardUI className='g_m_top_100' title='Collections, Payments and Cash Profits - on Bank Basis (Yearly)'>
      <LineChart width={800} height={400} data={chartYearlyData}
        margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
        <XAxis type='category' dataKey='financialYear' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" >
          <Label
            value={'Collections and Payments'}
            position='left'
            angle={-90}
            dy={-250}
            dx={-100}
          />
          <Label
            value={'Cash Profits'}
            position='right'
            angle={-90}
            dy={-120}
            dx={100}
          />
        </XAxis>
        <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
        <YAxis type='number' yAxisId='right' orientation='right' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
        <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
        <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
        <Line name='Collections' yAxisId='left' type='monotone' dataKey={dataKeys.revenue} stroke='green' />
        <Line name='Payments' yAxisId='left' type='monotone' dataKey={dataKeys.expense} stroke='red' />
        <Line name='Cash Profits' yAxisId='right' type='monotone' dataKey={dataKeys.netProfit} stroke='blue' />
      </LineChart>
    </CardUI>

    <CardUI className='g_m_top_100'
      title={
        <div className='g_flex_h g_m_bottom_50'>
          <span>Collections, Payments and Cash Profits - on Bank Basis</span>
          <span className='g_flex_h g_flex_right'>
            <SelectUI selectedKey={lastMonths} optionList={lastMonthsList} onChange={onLastMonthsChange} placeholder='Last 12 months' />
            <span className='g_m_left_50'>
              <SelectUI selectedKey={financialYear} optionList={financialYearList} onChange={onFinancialYearChange} placeholder='Financial year' />
            </span>
          </span>
        </div>
      }
    >
      <LineChart width={800} height={400} data={lastMonthsChartData}
        margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
        <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" >
          <Label
            value={'Collections and Payments'}
            position='left'
            angle={-90}
            dy={-250}
            dx={-100}
          />
          <Label
            value={'Cash Profits'}
            position='right'
            angle={-90}
            dy={-120}
            dx={100}
          />
        </XAxis>
        <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
        <YAxis type='number' yAxisId='right' orientation='right' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
        <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
        <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
        <Line name='Collections' yAxisId='left' type='monotone' dataKey={dataKeys.revenue} stroke='green' />
        <Line name='Payments' yAxisId='left' type='monotone' dataKey={dataKeys.expense} stroke='red' />
        <Line name='Net Payments' yAxisId='left' type='monotone' dataKey={dataKeys.bankNetExpense} stroke='purple' />
        <Line name='Cash Profits' yAxisId='right' type='monotone' dataKey={dataKeys.netProfit} stroke='blue' />
      </LineChart>
    </CardUI>

    <CardUI className='g_m_top_100' title='Collections, Payments and Cash Profits - on Bank Basis (Quaterly)'>
      <div className='g_flex_h'>
        <LineChart width={400} height={300} data={quaterlyData[0]}
          margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
          <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" >
            <Label
              value={'Collections and Payments'}
              position='left'
              angle={-90}
              dy={-180}
              dx={-100}
            />
            <Label
              value={'Cash Profits'}
              position='right'
              angle={-90}
              dy={-70}
              dx={100}
            />
          </XAxis>
          <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <YAxis type='number' yAxisId='right' orientation='right' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
          <Line name='Collections' yAxisId='left' type='monotone' dataKey={dataKeys.revenue} stroke='green' />
          <Line name='Payments' yAxisId='left' type='monotone' dataKey={dataKeys.expense} stroke='red' />
          <Line name='Net Payments' yAxisId='left' type='monotone' dataKey={dataKeys.bankNetExpense} stroke='purple' />
          <Line name='Cash Profits' yAxisId='right' type='monotone' dataKey={dataKeys.netProfit} stroke='blue' />
        </LineChart>

        <LineChart width={400} height={300} data={quaterlyData[1]}
          margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
          <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" >
            <Label
              value={'Collections and Payments'}
              position='left'
              angle={-90}
              dy={-180}
              dx={-100}
            />
            <Label
              value={'Cash Profits'}
              position='right'
              angle={-90}
              dy={-70}
              dx={100}
            />
          </XAxis>
          <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <YAxis type='number' yAxisId='right' orientation='right' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
          <Line name='Collections' yAxisId='left' type='monotone' dataKey={dataKeys.revenue} stroke='green' />
          <Line name='Payments' yAxisId='left' type='monotone' dataKey={dataKeys.expense} stroke='red' />
          <Line name='Net Payments' yAxisId='left' type='monotone' dataKey={dataKeys.bankNetExpense} stroke='purple' />
          <Line name='Cash Profits' yAxisId='right' type='monotone' dataKey={dataKeys.netProfit} stroke='blue' />
        </LineChart>
      </div>

      <div className='g_flex_h g_m_top_100'>
        <LineChart width={400} height={300} data={quaterlyData[2]}
          margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
          <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" >
            <Label
              value={'Collections and Payments'}
              position='left'
              angle={-90}
              dy={-180}
              dx={-100}
            />
            <Label
              value={'Cash Profits'}
              position='right'
              angle={-90}
              dy={-70}
              dx={100}
            />
          </XAxis>
          <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <YAxis type='number' yAxisId='right' orientation='right' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
          <Line name='Collections' yAxisId='left' type='monotone' dataKey={dataKeys.revenue} stroke='green' />
          <Line name='Payments' yAxisId='left' type='monotone' dataKey={dataKeys.expense} stroke='red' />
          <Line name='Net Payments' yAxisId='left' type='monotone' dataKey={dataKeys.bankNetExpense} stroke='purple' />
          <Line name='Cash Profits' yAxisId='right' type='monotone' dataKey={dataKeys.netProfit} stroke='blue' />
        </LineChart>

        <LineChart width={400} height={300} data={quaterlyData[3]}
          margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
          <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" >
            <Label
              value={'Collections and Payments'}
              position='left'
              angle={-90}
              dy={-180}
              dx={-100}
            />
            <Label
              value={'Cash Profits'}
              position='right'
              angle={-90}
              dy={-70}
              dx={100}
            />
          </XAxis>
          <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <YAxis type='number' yAxisId='right' orientation='right' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
          <Line name='Collections' yAxisId='left' type='monotone' dataKey={dataKeys.revenue} stroke='green' />
          <Line name='Payments' yAxisId='left' type='monotone' dataKey={dataKeys.expense} stroke='red' />
          <Line name='Net Payments' yAxisId='left' type='monotone' dataKey={dataKeys.bankNetExpense} stroke='purple' />
          <Line name='Cash Profits' yAxisId='right' type='monotone' dataKey={dataKeys.netProfit} stroke='blue' />
        </LineChart>
      </div>
    </CardUI>

    <CardUI className='g_m_top_100'
      title={
        <div className='g_flex_h g_m_bottom_50'>
          <span>Collections, Payments and Cash Profits - on GST Basis</span>
          <span className='g_flex_h g_flex_right'>
            <SelectUI selectedKey={lastMonths} optionList={lastMonthsList} onChange={onLastMonthsChange} placeholder='Last 12 months' />
            <span className='g_m_left_50'>
              <SelectUI selectedKey={financialYear} optionList={financialYearList} onChange={onFinancialYearChange} placeholder='Financial year' />
            </span>
          </span>
        </div>
      }
    >
      <LineChart width={800} height={400} data={lastMonthsChartData}
        margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
        <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" >
          <Label
            value={'Collections and Payments'}
            position='left'
            angle={-90}
            dy={-250}
            dx={-100}
          />
          <Label
            value={'Cash Profits'}
            position='right'
            angle={-90}
            dy={-120}
            dx={100}
          />
        </XAxis>
        <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
        <YAxis type='number' yAxisId='right' orientation='right' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
        <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
        <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
        <Line name='Collections' yAxisId='left' type='monotone' dataKey={dataKeys.sales} stroke='green' />
        <Line name='Payments' yAxisId='left' type='monotone' dataKey={dataKeys.purchase} stroke='red' />
        <Line name='Net Payments' yAxisId='left' type='monotone' dataKey={dataKeys.gstNetExpense} stroke='purple' />
        <Line name='Cash Profits' yAxisId='right' type='monotone' dataKey={dataKeys.gstNetProfit} stroke='blue' />
      </LineChart>
    </CardUI>

    <CardUI className='g_m_top_100' title='Collections, Payments and Cash Profits - on GST Basis (Quaterly)'>
      <div className='g_flex_h'>
        <LineChart width={400} height={300} data={quaterlyData[0]}
          margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
          <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" >
            <Label
              value={'Collections and Payments'}
              position='left'
              angle={-90}
              dy={-180}
              dx={-100}
            />
            <Label
              value={'Cash Profits'}
              position='right'
              angle={-90}
              dy={-70}
              dx={100}
            />
          </XAxis>
          <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <YAxis type='number' yAxisId='right' orientation='right' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
          <Line name='Collections' yAxisId='left' type='monotone' dataKey={dataKeys.sales} stroke='green' />
          <Line name='Payments' yAxisId='left' type='monotone' dataKey={dataKeys.purchase} stroke='red' />
          <Line name='Net Payments' yAxisId='left' type='monotone' dataKey={dataKeys.gstNetExpense} stroke='purple' />
          <Line name='Cash Profits' yAxisId='right' type='monotone' dataKey={dataKeys.gstNetProfit} stroke='blue' />
        </LineChart>

        <LineChart width={400} height={300} data={quaterlyData[1]}
          margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
          <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" >
            <Label
              value={'Collections and Payments'}
              position='left'
              angle={-90}
              dy={-180}
              dx={-100}
            />
            <Label
              value={'Cash Profits'}
              position='right'
              angle={-90}
              dy={-70}
              dx={100}
            />
          </XAxis>
          <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <YAxis type='number' yAxisId='right' orientation='right' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
          <Line name='Collections' yAxisId='left' type='monotone' dataKey={dataKeys.sales} stroke='green' />
          <Line name='Payments' yAxisId='left' type='monotone' dataKey={dataKeys.purchase} stroke='red' />
          <Line name='Net Payments' yAxisId='left' type='monotone' dataKey={dataKeys.gstNetExpense} stroke='purple' />
          <Line name='Cash Profits' yAxisId='right' type='monotone' dataKey={dataKeys.gstNetProfit} stroke='blue' />
        </LineChart>
      </div>

      <div className='g_flex_h g_m_top_100'>
        <LineChart width={400} height={300} data={quaterlyData[2]}
          margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
          <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" >
            <Label
              value={'Collections and Payments'}
              position='left'
              angle={-90}
              dy={-180}
              dx={-100}
            />
            <Label
              value={'Cash Profits'}
              position='right'
              angle={-90}
              dy={-70}
              dx={100}
            />
          </XAxis>
          <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <YAxis type='number' yAxisId='right' orientation='right' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
          <Line name='Collections' yAxisId='left' type='monotone' dataKey={dataKeys.sales} stroke='green' />
          <Line name='Payments' yAxisId='left' type='monotone' dataKey={dataKeys.purchase} stroke='red' />
          <Line name='Net Payments' yAxisId='left' type='monotone' dataKey={dataKeys.gstNetExpense} stroke='purple' />
          <Line name='Cash Profits' yAxisId='right' type='monotone' dataKey={dataKeys.gstNetProfit} stroke='blue' />
        </LineChart>

        <LineChart width={400} height={300} data={quaterlyData[3]}
          margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
          <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" >
            <Label
              value={'Collections and Payments'}
              position='left'
              angle={-90}
              dy={-180}
              dx={-100}
            />
            <Label
              value={'Cash Profits'}
              position='right'
              angle={-90}
              dy={-70}
              dx={100}
            />
          </XAxis>
          <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <YAxis type='number' yAxisId='right' orientation='right' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
          <Line name='Collections' yAxisId='left' type='monotone' dataKey={dataKeys.sales} stroke='green' />
          <Line name='Payments' yAxisId='left' type='monotone' dataKey={dataKeys.purchase} stroke='red' />
          <Line name='Net Payments' yAxisId='left' type='monotone' dataKey={dataKeys.gstNetExpense} stroke='purple' />
          <Line name='Cash Profits' yAxisId='right' type='monotone' dataKey={dataKeys.gstNetProfit} stroke='blue' />
        </LineChart>
      </div>
    </CardUI>

    <CardUI className='g_m_top_100 g_m_bottom_100'
      title={
        <div className='g_flex_h g_m_bottom_50'>
          <span>Trend on Triangulation</span>
          <span className='g_flex_h g_flex_right'>
            <SelectUI selectedKey={lastMonths} optionList={lastMonthsList} onChange={onLastMonthsChange} placeholder='Last 12 months' />
            <span className='g_m_left_50'>
              <SelectUI selectedKey={financialYear} optionList={financialYearList} onChange={onFinancialYearChange} placeholder='Financial year' />
            </span>
          </span>
        </div>
      }
    >
      <LineChart width={800} height={400} data={lastMonthsChartData}
        margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
        <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" />
        <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
        <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
        <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
        <Line name='Bank Collections' yAxisId='left' type='monotone' dataKey={dataKeys.bankRevenue} stroke='green' />
        <Line name='Bank Payments' yAxisId='left' type='monotone' dataKey={dataKeys.bankExpense} stroke='red' />
        <Line name='GST Sales' yAxisId='left' type='monotone' dataKey={dataKeys.gstSales} stroke='purple' />
        <Line name='GST Purchases' yAxisId='left' type='monotone' dataKey={dataKeys.gstPurchase} stroke='orange' />
      </LineChart>
    </CardUI>

    <CardUI className='g_m_top_100' title='Trend on Receivables'>
      <LineChart width={800} height={400} data={chartFromAprilData}
        margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
        <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" />
        <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
        <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
        <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
        <Line name='Receivables' yAxisId='left' type='monotone' dataKey={dataKeys.receivables} stroke='purple' />
        <Line name='Advances Received' yAxisId='left' type='monotone' dataKey={dataKeys.advancesReceived} stroke='orange' />
      </LineChart>
    </CardUI>

    <CardUI className='g_m_top_100' title='Trend on Payables'>
      <LineChart width={800} height={400} data={chartFromAprilData}
        margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
        <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" />
        <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
        <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
        <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
        <Line name='Payables' yAxisId='left' type='monotone' dataKey={dataKeys.payables} stroke='purple' />
        <Line name='Advances Paid' yAxisId='left' type='monotone' dataKey={dataKeys.advancesPaid} stroke='orange' />
      </LineChart>
    </CardUI>

    <Link className='g_m_left_100' to='#' onClick={onShowGpVNp}>Show gross profits vs net profits</Link>
    <Link className='g_m_left_100' to='#' onClick={onShowExpensesChart}>Show trend on payments</Link>

    {
      showGpVNp &&
      <CardUI className='g_m_top_100'
        title={
          <div className='g_flex_h g_m_bottom_50'>
            <span>Gross Profits vs Net Profits</span>
            <SelectUI selectedKey={lastMonths} optionList={lastMonthsList} onChange={onLastMonthsChange} placeholder='Last 12 months' />
          </div>
        }
      >
        <LineChart width={800} height={400} data={lastMonthsChartData}
          margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
          <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" />
          <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tick={(tickObject) => customTick(tickObject)} />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
          <Line name='Cash Profits' yAxisId='left' type='monotone' dataKey={dataKeys.cashProfit} stroke='green' />
          <Line name='Net Profits' yAxisId='left' type='monotone' dataKey={dataKeys.netProfit} stroke='red' />
        </LineChart>
      </CardUI>
    }
    {
      showExpensesChart &&
      <CardUI className='g_m_top_100'
        title={
          <div className='g_flex_h g_m_bottom_50'>
            <span>Trend on Payments</span>
            <SelectUI selectedKey={lastMonths} optionList={lastMonthsList} onChange={onLastMonthsChange} placeholder='Last 12 months' />
          </div>
        }
      >
        <LineChart width={800} height={400} data={lastMonthsChartData}
          margin={{ top: 20, right: 50, bottom: 40, left: 60 }} >
          <XAxis type='category' dataKey='yearMonth' padding={{ left: 30, right: 30 }} angle={-45} textAnchor="end" />
          <YAxis type='number' yAxisId='left' domain={[0, 'auto']} tickFormatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-IN').format(value)} />
          <Legend onClick={selectLine} wrapperStyle={{ bottom: 0 }} />
          <Line name='Salary Costs' yAxisId='left' type='monotone' dataKey={dataKeys.bankSalary} stroke='green' />
          <Line name='EMI' yAxisId='left' type='monotone' dataKey={dataKeys.bankEmi} stroke='red' />
          <Line name='Finance Costs' yAxisId='left' type='monotone' dataKey={dataKeys.bankFinanceCost} stroke='purple' />
          <Line name='Bank Charges' yAxisId='left' type='monotone' dataKey={dataKeys.bankCharges} stroke='blue' />
          <Line name='Other Expenses' yAxisId='left' type='monotone' dataKey={dataKeys.bankOtherExpense} stroke='orange' />
        </LineChart>
      </CardUI>
    }
  </div>

const customTick = (tickObject) => {
  const {
    payload: { value }
  } = tickObject
  return <Text {...tickObject}>{value < 0 ? `(${new Intl.NumberFormat('en-IN').format(value)})` : new Intl.NumberFormat('en-IN').format(value)}</Text>
}

export default ChartsUI
